/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { DatePicker,message} from "antd";
import Select from "react-select";
import { Link, Navigate, useNavigate } from 'react-router-dom';
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Country, State } from "country-state-city";
import { addhospital, gethospital } from "../../services/admin/hospital/hospital";
import { adddoctor } from "../../services/admin/doctor/doctor";
import { useMessageApi } from "../../services/message api/MessageProvider";

const AddDoctor = () => {



  const [isClicked, setIsClicked] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  // console.log(selectedOption);

  const [country, setCountry] = useState();
  const [statevalue, setStateValue] = useState();

  useEffect(() => {
    const states = State.getStatesOfCountry("IN"); 
    const formattedStates = states.map((state) => ({
      label: state.name,
      value: state.name,
    }));
    const options = Country.getAllCountries()?.map((country) => ({
      label: country.name,
      value: country.id,
    }));
    setCountry(options);
    setStateValue(formattedStates);
    fetchHospitals();
  }, []); 

  const [hospital, setHospital] = useState([]);
  const doctorTypeOptions = [
  { id: 1, name: "Pediatrics" }, { id: 2, name: "Internal Medicine" },
  { id: 3, name: "General Practice" }, { id: 4, name: "Cardiology" },
  { id: 5, name: "Urology" }, { id: 6, name: "Diabetology" },
  { id: 7, name: "Pulmonology" }, { id: 8, name: "Gastroenterology" },
  { id: 9, name: "Dermatology" }, { id: 10, name: "Endocrinology" },
  { id: 11, name: "Gynaecology" }, { id: 12, name: "E.N.T." },
  { id: 13, name: "Orthopedics" }, { id: 14, name: "Psychiatry" },
  { id: 15, name: "Neurology" }, { id: 16, name: "Nephrology" },
  { id: 17, name: "Dentistry" }, { id: 18, name: "Oncology" },
  { id: 19, name: "Hematology" }
].map(item => ({ label: item.name, value: item.id }));

const moduleOptions = [
  { id: 1, name: "Consult" }, { id: 2, name: "Vaccination" },
  { id: 3, name: "Check-up" }, { id: 4, name: "Certificates" },
  { id: 5, name: "Growth" }, { id: 6, name: "Investigations" },
  { id: 7, name: "Fitness" }, { id: 8, name: "Procedures" },
  { id: 9, name: "OBGYN" }, { id: 10, name: "Patient Timeline" },
  { id: 11, name: "Upload" }
].map(item => ({ label: item.name, value: item.id }));

  const [formData, setFormData] = useState({
    parent_user_id:"",
    name: "",
    last_name:"",
    middle_name:"",
    mobile: "",
    email: "",
    password: "",
    password_confirmation: "",
    gender:"",
    designation: "",
    qualification: "",
    speciality:"",
    mci_registration_number:"",
    date_of_birth:"",
    doctor_types:[],
    module_permissions:[],
    address:"",
    city:"",
    country:"",
    state:"",
    pincode:"",
    status:""
  });

  // console.log(formData);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};

    if (!formData?.parent_user_id) {
      newErrors.parent_user_id = "hospital is required";
    }
    if (!formData.name.trim()) {
      newErrors.name = "First Name is required";
    }
    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last Name is required";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    }

    if (!formData.password.trim()) {
      newErrors.password = "Password is required";
    }

    if (!formData.password_confirmation.trim()) {
      newErrors.password_confirmation = "Confirm Password is required";
    } else if (formData.password_confirmation !== formData.password) {
      newErrors.password_confirmation = "Passwords does not match";
    }
    if (!formData.status.trim()) {
      newErrors.status = "Status is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleChange = (selectedOption, fieldName) => {

  setFormData((prevData) => {
    let newData = { ...prevData };

    // Handle standard HTML inputs
    if (selectedOption?.target) {
      const { name, value } = selectedOption.target;
      newData[name] = value;
    } 
    // Handle React-Select
    else if (fieldName) {
      if (Array.isArray(selectedOption)) {
        // Multi-select (Module): map to [{ id: x, name: y }, ...]
        newData[fieldName] = selectedOption.map((opt) => ({
          id: opt.value,
          name: opt.label,
        }));
      } else if (selectedOption && typeof selectedOption === "object") {
        // Single-select (Doctor Type): map to [{ id: x, name: y }]
        newData[fieldName] = [
          {
            id: selectedOption.value,
            name: selectedOption.label,
          }
        ];
      } else {
        // Fallback for clearing
        if( fieldName === 'parent_user_id' )
        {
          newData[fieldName] = selectedOption;
        }
        else
        {
          newData[fieldName] = (fieldName === 'doctor_types' || fieldName === 'module_permissions') ? [] : "";
        }
      }
    }
    return newData;
  });
};

  const fetchHospitals = async () => {
    try {
      const result = await gethospital();
      // console.log("Hospital data:", result);
      const options = result?.data?.map((hospital) => ({
        label: hospital.name,
        value: hospital.id,
      }));
      setHospital(options);
    }
    catch (err) {
      console.error("Exception:", err.message);
    }
  }


  message.config({
    top: 100, // distance from top
    duration: 3,
    placement: 'topRight', // <-- key part for right side
  });
const messageApi = useMessageApi();

  const handleSubmit = async (e) => {
    e.preventDefault();

    e.preventDefault();
    
      if (validateForm()) {
        console.log("Form submitted successfully!", formData);
        try {
          const result = await adddoctor(formData); 
          if (result.success) {
            messageApi.open({
              type: 'success',
              content: 'Doctor added successfully!',
            });
            
                navigate('/doctorlist');

          } else {
            const errors = result?.error;
      
            Object.entries(errors).forEach(([field, messages]) => {
              const messageArray = Array.isArray(messages) ? messages : [messages];
            
              messageArray.forEach((msg) => {
                messageApi.open({
                  type: 'error',
                  content: `${field}: ${msg}`,
                  style: {
                    maxWidth: '300px',
                    minWidth: '300px',
                    textAlign: 'left',
                    wordBreak: 'break-word',
                    marginLeft: 'auto', // aligns to right in combination with topRight
                    marginRight: '0',
                  },
                });
              });
            });
            
            
          }
        } catch (error) {
          console.error("Error adding hospital:", error?.message);
          // Show error to user
        }
      } else {
        console.log("Form validation failed");
      }
  };

  const navigate = useNavigate();
  const handleCancel = () => {
    navigate('/doctorlist');
  };
  
  

  return (
    <div>
      <Header />
      <Sidebar activeClassName="doctor" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/doctorlist">Doctors </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">Add Doctor</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Doctor Details</h4>
                          </div>
                        </div>
                        <div className="col-12 col-md-13 col-xl-12">
                          <div className="form-group local-forms">
                            <label>
                              Select Hospital{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <Select
                              menuPosition={"fixed"}
                              name="hospital"
                              defaultValue={selectedOption}
                              onChange={(selectedOption) =>
                                handleChange(
                                  selectedOption.value,
                                  "parent_user_id"
                                )
                              }
                              options={hospital}
                              menuPortalTarget={document.body}
                              id="search-commodity"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),

                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1)",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),

                                option: (base, state) => ({
                                  ...base,
                                  backgroundColor: state.isFocused
                                    ? "rgba(46, 55, 164, 0.1)"
                                    : "white",
                                  color: "black", // make sure text is visible
                                  cursor: "pointer",
                                  fontSize: "14px",
                                }),

                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                            {errors.parent_user_id && (
                              <p style={{ color: "red" }}>
                                {errors.parent_user_id}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              First Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="name"
                              type="text"
                              placeholder=""
                              onChange={(e) => {
                                const formatted = e.target.value
                                  .toLowerCase()
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  );
                                e.target.value = formatted;
                                handleChange(e); // keep your existing handler
                              }}
                            />
                            {errors.name && (
                              <p style={{ color: "red" }}>{errors.name}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>Middle Name</label>
                            <input
                              className="form-control"
                              name="middle_name"
                              type="text"
                              placeholder=""
                              onChange={(e) => {
                                const formatted = e.target.value
                                  .toLowerCase()
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  );
                                e.target.value = formatted;
                                handleChange(e); // keep your existing handler
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-4">
                          <div className="form-group local-forms">
                            <label>
                              Last Name <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="last_name"
                              type="text"
                              placeholder=""
                              onChange={(e) => {
                                const formatted = e.target.value
                                  .toLowerCase()
                                  .replace(/\b\w/g, (char) =>
                                    char.toUpperCase()
                                  );
                                e.target.value = formatted;
                                handleChange(e); // keep your existing handler
                              }}
                            />
                            {errors.last_name && (
                              <p style={{ color: "red" }}>{errors.last_name}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Mobile <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="mobile"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.mobile && (
                              <p style={{ color: "red" }}>{errors.mobile}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Email <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="email"
                              type="email"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.email && (
                              <p style={{ color: "red" }}>{errors.email}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Password <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="password"
                              type="password"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.password && (
                              <p style={{ color: "red" }}>{errors.password}</p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>
                              Confirm Password{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              name="password_confirmation"
                              type="password"
                              placeholder=""
                              onChange={handleChange}
                            />
                            {errors.password_confirmation && (
                              <p style={{ color: "red" }}>
                                {errors.password_confirmation}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Doctor Type </label>
                            <Select
                              menuPosition={"fixed"}
                              defaultValue={selectedOption}
                              name="doctor_types"
                              onChange={(val) =>
                                handleChange(val, "doctor_types")
                              } // Pass the full object
                              options={doctorTypeOptions}
                              placeholder="Select Doctor Type"
                              menuPortalTarget={document.body}
                              id="search-commodity"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1);",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Module</label>
                            <Select
                              isMulti // Enables multi-select
                              menuPosition={"fixed"}
                              name="module_permissions"
                              defaultValue={selectedOption}
                              // Pass the whole array to handleChange
                              onChange={(val) => handleChange(val, "module_permissions")}
                              options={moduleOptions}
                              menuPortalTarget={document.body}
                              placeholder="Select Modules"
                              id="module-select"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1);",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                // Styles for the "tags" (multi-select values)
                                multiValue: (base) => ({
                                  ...base,
                                  backgroundColor: "rgba(46, 55, 164, 0.1)",
                                  borderRadius: "5px",
                                }),
                                multiValueLabel: (base) => ({
                                  ...base,
                                  color: "#2e37a4",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Designation</label>
                            <input
                              className="form-control"
                              name="designation"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Qualification</label>
                            <input
                              className="form-control"
                              name="qualification"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>Speciality</label>
                            <input
                              className="form-control"
                              name="speciality"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms">
                            <label>MCI Registration Number</label>
                            <input
                              className="form-control"
                              name="mci_registration_number"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-6">
                          <div className="form-group local-forms cal-icon">
                            <label>Date Of Birth </label>
                            <DatePicker
                              className="form-control datetimepicker"
                              selected={formData.date_of_birth}
                              onChange={(date) =>
                                handleChange(
                                  date.toISOString().split("T")[0],
                                  "date_of_birth"
                                )
                              }
                              suffixIcon={null}
                              style={{
                                borderColor: isClicked
                                  ? "#2E37A4"
                                  : "2px solid rgba(46, 55, 164, 0.1)",
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group select-gender">
                            <label className="gen-label">Gender</label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="gender"
                                  onChange={handleChange}
                                  value="male"
                                  className="form-check-input"
                                />
                                Male
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  onChange={handleChange}
                                  value="female"
                                  name="gender"
                                  className="form-check-input"
                                />
                                Female
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group select-gender">
                            <label className="gen-label">
                              Status<span className="login-danger">*</span>
                            </label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="status"
                                  onChange={handleChange}
                                  value="Active"
                                  className="form-check-input"
                                />
                                Active
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  onChange={handleChange}
                                  value="Deactivate"
                                  name="status"
                                  className="form-check-input"
                                />
                                Deactive
                              </label>
                            </div>
                            {errors.status && (
                              <p style={{ color: "red" }}>{errors.status}</p>
                            )}
                          </div>
                        </div>

                        <div className="col-12 col-sm-12">
                          <div className="form-group local-forms">
                            <label>Address</label>
                            <textarea
                              className="form-control"
                              name="address"
                              onChange={handleChange}
                              rows={3}
                              cols={30}
                              defaultValue={""}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>City</label>
                            <input
                              className="form-control"
                              name="city"
                              type="text"
                              placeholder=""
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>State </label>
                            <Select
                              menuPosition={"fixed"}
                              name="state"
                              defaultValue={selectedOption}
                              onChange={(selectedOption) =>
                                handleChange(selectedOption?.label, "state")
                              }
                              options={statevalue}
                              menuPortalTarget={document.body}
                              id="search-commodity"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1);",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>Country</label>
                            <Select
                              menuPosition={"fixed"}
                              name="country"
                              defaultValue={selectedOption}
                              onChange={(selectedOption) =>
                                handleChange(selectedOption.label, "country")
                              }
                              options={country}
                              menuPortalTarget={document.body}
                              id="search-commodity"
                              components={{
                                IndicatorSeparator: () => null,
                              }}
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  borderColor: state.isFocused
                                    ? "none"
                                    : "2px solid rgba(46, 55, 164, 0.1);",
                                  boxShadow: state.isFocused
                                    ? "0 0 0 1px #2e37a4"
                                    : "none",
                                  "&:hover": {
                                    borderColor: state.isFocused
                                      ? "none"
                                      : "2px solid rgba(46, 55, 164, 0.1)",
                                  },
                                  borderRadius: "10px",
                                  fontSize: "14px",
                                  minHeight: "45px",
                                }),
                                dropdownIndicator: (base, state) => ({
                                  ...base,
                                  transform: state.selectProps.menuIsOpen
                                    ? "rotate(-180deg)"
                                    : "rotate(0)",
                                  transition: "250ms",
                                  width: "35px",
                                  height: "35px",
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-6 col-xl-3">
                          <div className="form-group local-forms">
                            <label>Postal Code </label>
                            <input
                              name="pincode"
                              onChange={handleChange}
                              className="form-control"
                              type="text"
                              placeholder=""
                            />
                          </div>
                        </div>

                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary cancel-form"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="notification-box">
            <div className="msg-sidebar notifications msg-noti">
              <div className="topnav-dropdown-header">
                <span>Messages</span>
              </div>
              <div className="drop-scroll msg-list-scroll" id="msg_list">
                <ul className="list-box">
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Richard Miles </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item new-message">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">John Doe</span>
                          <span className="message-time">1 Aug</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Tarah Shropshire{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Mike Litorus</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Catherine Manseau{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">D</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Domenic Houston{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">B</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Buster Wigton{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">R</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            {" "}
                            Rolland Webber{" "}
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">C</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author"> Claire Mapes </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">M</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Melita Faucher</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">J</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Jeffery Lalor</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">L</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">Loren Gatlin</span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <div className="list-item">
                        <div className="list-left">
                          <span className="avatar">T</span>
                        </div>
                        <div className="list-body">
                          <span className="message-author">
                            Tarah Shropshire
                          </span>
                          <span className="message-time">12:28 AM</span>
                          <div className="clearfix" />
                          <span className="message-content">
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="#">See all messages</Link>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default AddDoctor;
